import { useState, useEffect } from "react";
import * as api from "./api";
import { Svg, G, A, ALt, P, OK, E, ELt, cardS, inputS, labelS, Toast,
  iBack, iGear, iUser, iPlus, iSave, iX } from "./shared";

export default function SettingsScreen({ me, setMe, setScreen, mode }) {
  // 탭 & 보안
  var [settingTab, setSettingTab] = useState(mode==="collect"?"general":"password");
  var [stToast, setStToast] = useState("");
  function showToast(m) { setStToast(m); setTimeout(function(){ setStToast(""); }, 2500); }
  var [curPw, setCurPw] = useState("");
  var [newPw, setNewPw] = useState("");
  var [newPw2, setNewPw2] = useState("");
  var [pwMsg, setPwMsg] = useState("");
  var isSuper = me && me.isSuper;
  async function doChangePassword() {
    if (!curPw || !newPw) { setPwMsg("현재/새 비밀번호를 입력해주세요."); return; }
    if (newPw.length < 6) { setPwMsg("6자 이상이어야 합니다."); return; }
    if (newPw !== newPw2) { setPwMsg("일치하지 않습니다."); return; }
    try { await api.changePassword(curPw, newPw); setCurPw(""); setNewPw(""); setNewPw2(""); setPwMsg("변경 완료"); } catch(e) { setPwMsg("오류: "+(e.message||"실패")); }
  }

  var [brandName, setBrandName] = useState((me && me.branding && me.branding.name) || "");
  var [brandColor, setBrandColor] = useState((me && me.branding && me.branding.color) || "#2E75B6");
  var [senderName, setSenderName] = useState((me && me.senderName) || "");
  var [senderNums, setSenderNums] = useState((me && me.senderNums) || []);
  var [newNum, setNewNum] = useState("");
  var [saved, setSaved] = useState("");
  var [emailSaved, setEmailSaved] = useState("");
  var [replyEmail, setReplyEmail] = useState((me && me.replyEmail) || "");
  var [logoFile, setLogoFile] = useState(null);
  var [logoPreview, setLogoPreview] = useState((me && me.branding && me.branding.logo && (me.branding.logo.startsWith("http") || me.branding.logo.startsWith("data:")) ? me.branding.logo : "") || "");
  // 프로젝트명 프리셋
  var [projNames, setProjNames] = useState([]);
  var [newProjName, setNewProjName] = useState("");
  // 소개자(FP) 관리
  var [fpList, setFpList] = useState([]);
  var [newFp, setNewFp] = useState({ name:"", phone:"", email:"" });
  var [editFpId, setEditFpId] = useState(null);
  var [editFp, setEditFp] = useState({ name:"", phone:"", email:"" });

  // 프리셋/FP 로드
  useEffect(function() {
    if (settingTab === "accounts" && me && me.isSuper && accounts.length === 0) { loadAccounts(); }
    if (settingTab === "modules" && me && me.isSuper) { loadAllModules(); }
  }, [settingTab]);

  useEffect(function() {
    // 로고 presigned URL 갱신 (만료 방지)
    api.getMe().then(function(updated) {
      if (updated.branding && updated.branding.logo) {
        setLogoPreview(updated.branding.logo);
        setMe(function(prev) { return Object.assign({}, prev, { branding: updated.branding }); });
      }
    }).catch(function() {});
    // 프리셋/FP 로드
    if (me && me.isSuper) {
      api.getProjectNames().then(function(d){ setProjNames(d); }).catch(function(){});
      api.getReferrers().then(function(d){ setFpList(d); }).catch(function(){});
    }
  }, []);

  async function addProjName() {
    if (!newProjName.trim()) return;
    try { var row = await api.addProjectName(newProjName.trim()); setProjNames(function(p){ return p.concat([row]); }); setNewProjName(""); } catch(e) { showToast(e.message); }
  }
  async function delProjName(id) {
    if (!window.confirm("이 프로젝트명을 삭제하시겠습니까?")) return;
    try { await api.deleteProjectName(id); setProjNames(function(p){ return p.filter(function(r){ return r.id !== id; }); }); } catch(e) { showToast(e.message); }
  }
  async function addFpItem() {
    if (!newFp.name.trim()) return;
    try { var row = await api.addReferrer(newFp); setFpList(function(p){ return p.concat([row]); }); setNewFp({name:"",phone:"",email:""}); } catch(e) { showToast(e.message); }
  }
  async function saveFpEdit(id) {
    try { var row = await api.updateReferrer(id, editFp); setFpList(function(p){ return p.map(function(r){ return r.id===id?row:r; }); }); setEditFpId(null); } catch(e) { showToast(e.message); }
  }
  async function delFpItem(id) {
    if (!window.confirm("이 소개자를 삭제하시겠습니까?")) return;
    try { await api.deleteReferrer(id); setFpList(function(p){ return p.filter(function(r){ return r.id !== id; }); }); } catch(e) { showToast(e.message); }
  }

  // 계정 관리
  var [accounts, setAccounts] = useState([]);
  var [showAccounts, setShowAccounts] = useState(false);
  var [showNewAccount, setShowNewAccount] = useState(false);
  var [newAcct, setNewAcct] = useState({ username:"", name:"", pw:"" });
  var [accNewUser, setAccNewUser] = useState("");
  var [accNewName, setAccNewName] = useState("");
  var [accNewPw, setAccNewPw] = useState("");
  var [accMsg, setAccMsg] = useState("");
  var [allModules, setAllModules] = useState([]);
  var [newModKey, setNewModKey] = useState("");
  var [newModLabel, setNewModLabel] = useState("");
  var [newModRoute, setNewModRoute] = useState("");
  var [newModColor, setNewModColor] = useState("#2E75B6");
  var [newModBg, setNewModBg] = useState("#EFF6FF");
  var [modMsg, setModMsg] = useState("");
  var [permMap, setPermMap] = useState({});

  async function loadAccounts() {
    try {
      var data = await api.getAccounts();
      setAccounts(data);
      setShowAccounts(true); loadAllModules();
      loadPerms(data);
    } catch(e) { showToast(e.message); }
  }


  async function loadPerms(accsParam) {
    try {
      var accs = accsParam || accounts || [];
      var map = {};
      for (var i = 0; i < accs.length; i++) {
        if (!accs[i].isSuper) {
          try {
            var res = await api.getAccountModules(accs[i].id);
            map[accs[i].id] = (res && res.data) ? res.data : (Array.isArray(res) ? res : []);
          } catch(e) { map[accs[i].id] = []; }
        }
      }
      setPermMap(map);
    } catch(e) {}
  }


  async function loadAllModules() {
    try {
      var res = await api.getModules();
      var data = (res && res.data) ? res.data : (Array.isArray(res) ? res : []);
      setAllModules(data);
    } catch(e) { showToast("모듈 로딩 오류: "+e.message); }
  }

  async function doCreateModule() {
    if (!newModKey.trim() || !newModLabel.trim()) { showToast("key와 표시명은 필수입니다."); return; }
    try {
      await api.createModule({ key: newModKey.trim(), label: newModLabel.trim(), screen_route: newModRoute.trim() || null, color: newModColor, bg_color: newModBg });
      setNewModKey(""); setNewModLabel(""); setNewModRoute("");
      loadAllModules();
      showToast("모듈 추가 완료");
    } catch(e) { showToast("오류: "+e.message); }
  }

  async function doDeleteModule(mod) {
    if (!window.confirm(mod.label + " 모듈을 삭제하시겠습니까?")) return;
    try {
      await api.deleteModule(mod.id);
      loadAllModules();
      showToast("모듈 삭제 완료");
    } catch(e) { showToast("오류: "+e.message); }
  }

  async function toggleModuleActive(mod) {
    try {
      await api.updateModule(mod.id, { is_active: !mod.is_active });
      loadAllModules();
      showToast(mod.label.replace("\n"," ") + (mod.is_active ? " 비활성화" : " 활성화"));
    } catch(e) { showToast("오류: "+e.message); }
  }

  async function togglePerm(accId, modId) {
    try {
      var mods = permMap[accId] || [];
      var idx = mods.indexOf(modId);
      var newMods = idx >= 0 ? mods.filter(function(m){ return m !== modId; }) : mods.concat([modId]);
      await api.setAccountModules(accId, newMods);
      setPermMap(function(p) { var c = Object.assign({}, p); c[accId] = newMods; return c; });
    } catch(e) { showToast("권한 변경 오류: "+e.message); }
  }

  
  async function saveLogo() {
    if (!logoFile) { showToast("로고 파일을 선택해주세요."); return; }
    try {
      await api.uploadLogo(logoFile);
      var updated = await api.getMe();
      setMe(function(prev) { return Object.assign({}, prev, { branding: updated.branding }); });
      // 저장 후에도 미리보기 유지 (FileReader에서 읽은 데이터 사용)
      var r = new FileReader(); r.onload = function(ev){ setLogoPreview(ev.target.result); }; r.readAsDataURL(logoFile);
      showToast("로고 저장 완료"); setLogoFile(null);
    } catch(e) { showToast(e.message); }
  }
  function handleLogoSelect(e) {
    var f = e.target.files && e.target.files[0];
    if (f) { setLogoFile(f); var r = new FileReader(); r.onload = function(ev){setLogoPreview(ev.target.result);}; r.readAsDataURL(f); }
  }

  async function saveReplyEmail() {
    try {
      await api.updateReplyEmail(replyEmail);
      setMe(function(prev) { return Object.assign({}, prev, { replyEmail: replyEmail }); });
      showToast("회신 이메일 저장 완료");
    } catch(e) { showToast("오류: " + e.message); }
  }

  async function saveBranding() {
    try {
      await api.updateBranding({ brandingName: brandName, brandingColor: brandColor });
      var updated = await api.getMe();
      setMe(function(prev) { return Object.assign({}, prev, { branding: updated.branding }); });
      localStorage.setItem("account", JSON.stringify(Object.assign({}, (function(){ try { return JSON.parse(localStorage.getItem("account") || "null") || me; } catch (e) { return me; } })(), { branding: updated.branding })));   // 저장된 계정(전환 중이면 그 계정)에 브랜드만 — 화면이 들고 있던 옛 계정으로 덮지 않게(2026-10-27)
      showToast("브랜딩 저장 완료");
    } catch(e) { showToast(e.message); }
  }

  async function saveSenderName() {
    try {
      await api.updateSenderName(senderName);
      setMe(function(prev) { return Object.assign({}, prev, { senderName: senderName }); });
      showToast("발신자명 저장 완료");
    } catch(e) { showToast(e.message); }
  }

  async function saveSenderNums() {
    try {
      await api.updateSenderNums(senderNums);
      setMe(function(prev) { return Object.assign({}, prev, { senderNums: senderNums }); });
      showToast("발신번호 저장 완료");
    } catch(e) { showToast(e.message); }
  }

  function addNum() {
    if (senderNums.length >= 4) { showToast("최대 4개까지 등록 가능합니다."); return; }
    setSenderNums(function(p) { return p.concat([""]); });
  }

  async function doCreateAccount() {
    if (!accNewUser.trim() || !accNewName.trim() || !accNewPw.trim()) {
      showToast("아이디, 이름, 비밀번호를 모두 입력해주세요."); return;
    }
    try {
      await api.createAccount({ username: accNewUser.trim(), name: accNewName.trim(), password: accNewPw.trim() });
      setAccNewUser(""); setAccNewName(""); setAccNewPw("");
      showToast("계정 추가 완료");
      loadAccounts();
    } catch(e) { showToast("오류: "+e.message); }
  }

  async function toggleAccount(id, active) {
    try {
      if (active) await api.deactivateAccount(id);
      else await api.activateAccount(id);
      loadAccounts();
    } catch(e) { showToast(e.message); }
  }

  return (
    <div style={{ maxWidth:600, margin:"0 auto", padding:"24px 16px 80px" }}>
      <button onClick={function(){setScreen(mode==="collect"?"list":"home");}} style={{ background:"none",border:"none",cursor:"pointer",display:"flex",alignItems:"center",gap:5,color:G[500],fontSize:13,padding:0,marginBottom:16 }}>
        <Svg d={iBack} s={15} c={G[500]} /> 홈으로
      </button>

      <div style={{ display:"flex",gap:0,marginBottom:20,borderBottom:"2px solid "+G[200],flexWrap:"wrap" }}>
        {(mode==="collect"?[{id:"general",l:"자료수집 설정"},{id:"password",l:"비밀번호"}]:[{id:"password",l:"비밀번호"}].concat(isSuper?[{id:"accounts",l:"계정 & 권한"},{id:"modules",l:"모듈 관리"}]:[])).map(function(t){
          var sel = settingTab===t.id;
          return <button key={t.id} onClick={function(){setSettingTab(t.id);}} style={{ padding:"10px 16px",border:"none",borderBottom:sel?"2px solid "+A:"2px solid transparent",background:"none",color:sel?A:G[500],fontWeight:sel?700:500,fontSize:13,cursor:"pointer",marginBottom:-2 }}>{t.l}</button>;
        })}
      </div>

      {settingTab === "password" && <div>
      {/* 비밀번호 변경 */}
      <div style={Object.assign({},cardS,{marginBottom:16})}>
        <div style={{ fontSize:14,fontWeight:700,color:G[900],marginBottom:12 }}>비밀번호 변경</div>
        <div style={{ display:"flex",gap:8,flexWrap:"wrap" }}>
          <input value={curPw} onChange={function(e){setCurPw(e.target.value);setPwMsg("");}} placeholder="현재 비밀번호" type="password" style={Object.assign({},inputS,{flex:1,minWidth:130})} />
          <input value={newPw} onChange={function(e){setNewPw(e.target.value);setPwMsg("");}} placeholder="새 비밀번호" type="password" style={Object.assign({},inputS,{flex:1,minWidth:130})} />
          <input value={newPw2} onChange={function(e){setNewPw2(e.target.value);setPwMsg("");}} placeholder="확인" type="password" style={Object.assign({},inputS,{flex:1,minWidth:100})} />
          <button onClick={doChangePassword} style={{ padding:"9px 18px",borderRadius:8,border:"none",background:A,color:"#fff",fontSize:13,fontWeight:600,cursor:"pointer" }}>변경</button>
        </div>
        {pwMsg && <div style={{ marginTop:8,fontSize:12,color:pwMsg.indexOf("오류")>=0?"#DC2626":"#059669" }}>{pwMsg}</div>}
      </div>

      </div>}

      {settingTab === "general" && <div>

      

      {/* 브랜딩 */}
      <div style={Object.assign({},cardS,{marginBottom:16})}>
        <div style={{ fontSize:14,fontWeight:700,color:G[900],marginBottom:12 }}>회사 브랜딩</div>
        <div style={{ display:"flex",gap:8,flexWrap:"wrap",marginBottom:10 }}>
          <div style={{ flex:1,minWidth:150 }}>
            <label style={labelS}>회사명 (브랜딩)</label>
            <input value={brandName} onChange={function(e){setBrandName(e.target.value);}} placeholder="포털에 표시될 회사명" style={Object.assign({},inputS,{width:"100%",boxSizing:"border-box"})} />
          </div>
          <div style={{ flex:1,minWidth:100 }}>
            <label style={labelS}>브랜드 색상</label>
            <input type="color" value={brandColor} onChange={function(e){setBrandColor(e.target.value);}} style={{ width:48,height:36,border:"1px solid "+G[200],borderRadius:6,cursor:"pointer" }} />
          </div>
        </div>
        <button onClick={saveBranding} style={{ padding:"8px 16px",borderRadius:8,border:"none",background:A,color:"#fff",fontSize:12,fontWeight:600,cursor:"pointer" }}>브랜딩 저장</button>
      </div>

      {/* 로고 */}
      <div style={Object.assign({},cardS,{marginBottom:16})}>
        <div style={{ fontSize:14,fontWeight:700,color:G[900],marginBottom:12 }}>회사 로고</div>
        {logoPreview && <img src={logoPreview} alt="logo" style={{ maxWidth:200,maxHeight:60,marginBottom:10,borderRadius:6,border:"1px solid "+G[200] }} />}
        <div style={{ display:"flex",gap:8,alignItems:"center" }}>
          <input type="file" accept="image/*" onChange={function(e){setLogoFile(e.target.files[0]||null);}} style={{ fontSize:12 }} />
          <button onClick={saveLogo} style={{ padding:"8px 16px",borderRadius:8,border:"none",background:A,color:"#fff",fontSize:12,fontWeight:600,cursor:"pointer" }}>로고 저장</button>
        </div>
      </div>

      {/* 발신자명 */}
      <div style={Object.assign({},cardS,{marginBottom:16})}>
        <div style={{ fontSize:14,fontWeight:700,color:G[900],marginBottom:12 }}>SMS 발신자명</div>
        <div style={{ display:"flex",gap:8 }}>
          <input value={senderName} onChange={function(e){setSenderName(e.target.value);}} placeholder="SMS 발신자명" style={Object.assign({},inputS,{flex:1})} />
          <button onClick={saveSenderName} style={{ padding:"8px 16px",borderRadius:8,border:"none",background:A,color:"#fff",fontSize:12,fontWeight:600,cursor:"pointer" }}>저장</button>
        </div>
      </div>

      {/* 발신번호 */}
      {isSuper && <div style={Object.assign({},cardS,{marginBottom:16})}>
        <div style={{ fontSize:14,fontWeight:700,color:G[900],marginBottom:12 }}>발신 전화번호</div>
        <p style={{ fontSize:11,color:G[400],margin:"0 0 8px" }}>SMS/알림톡 발신에 사용할 번호 (최대 4개)</p>
        {senderNums.map(function(num, idx) {
          return <div key={idx} style={{ display:"flex",alignItems:"center",gap:8,marginBottom:4 }}>
            <input value={num} onChange={function(e){var arr=senderNums.slice();arr[idx]=e.target.value;setSenderNums(arr);}} style={Object.assign({},inputS,{flex:1})} />
            <button onClick={function(){setSenderNums(senderNums.filter(function(_,i){return i!==idx;}));}} style={{ background:"none",border:"none",cursor:"pointer" }}><Svg d={iX} s={13} c={G[400]} /></button>
          </div>;
        })}
        <div style={{ display:"flex",gap:8,marginTop:6 }}>
          <button onClick={addNum} style={{ padding:"6px 12px",borderRadius:6,border:"1px dashed "+G[300],background:"#fff",color:G[500],fontSize:11,cursor:"pointer" }}>+ 번호 추가</button>
          <button onClick={saveSenderNums} style={{ padding:"6px 12px",borderRadius:6,border:"none",background:A,color:"#fff",fontSize:11,fontWeight:600,cursor:"pointer" }}>발신번호 저장</button>
        </div>
      </div>}

      {/* 회신 이메일 */}
      {isSuper && <div style={Object.assign({},cardS,{marginBottom:16})}>
        <div style={{ fontSize:14,fontWeight:700,color:G[900],marginBottom:12 }}>회신 이메일</div>
        <div style={{ display:"flex",gap:8 }}>
          <input value={replyEmail} onChange={function(e){setReplyEmail(e.target.value);}} placeholder="reply@company.com" style={Object.assign({},inputS,{flex:1})} />
          <button onClick={saveReplyEmail} style={{ padding:"8px 16px",borderRadius:8,border:"none",background:A,color:"#fff",fontSize:12,fontWeight:600,cursor:"pointer" }}>저장</button>
        </div>
      </div>}

      {/* 프리셋 & FP 관리 */}
      {isSuper && <div style={cardS}>
          {/* 프로젝트명 프리셋 */}
          <div style={{ marginBottom:20 }}>
            <div style={{ fontSize:14,fontWeight:700,color:G[900],marginBottom:10 }}>프로젝트명 프리셋</div>
            <p style={{ fontSize:11,color:G[400],margin:"0 0 8px" }}>자주 사용하는 프로젝트명을 등록해두면 프로젝트 생성시 선택 가능합니다.</p>
            {projNames.map(function(pn) {
              return <div key={pn.id} style={{ display:"flex",alignItems:"center",gap:8,padding:"6px 10px",borderRadius:6,border:"1px solid "+G[200],marginBottom:4 }}>
                <span style={{ flex:1,fontSize:12,color:G[700] }}>{pn.name}</span>
                <button onClick={function(){delProjName(pn.id);}} style={{ background:"none",border:"none",cursor:"pointer" }}><Svg d={iX} s={13} c={G[400]} /></button>
              </div>;
            })}
            <div style={{ display:"flex",gap:8,marginTop:6 }}>
              <input value={newProjName} onChange={function(e){setNewProjName(e.target.value);}} onKeyDown={function(e){if(e.key==="Enter")addProjName();}} placeholder="프로젝트명 입력" style={Object.assign({},inputS,{flex:1})} />
              <button onClick={addProjName} style={{ padding:"8px 14px",borderRadius:8,border:"1px solid "+G[200],background:"#fff",color:G[600],fontSize:12,cursor:"pointer",whiteSpace:"nowrap" }}>추가</button>
            </div>
          </div>

          {/* 소개자(FP) 관리 */}
          <div style={{ paddingTop:16,borderTop:"1px solid "+G[200] }}>
            <div style={{ fontSize:14,fontWeight:700,color:G[900],marginBottom:10 }}>소개자(FP) 관리</div>
            <p style={{ fontSize:11,color:G[400],margin:"0 0 8px" }}>등록된 소개자는 프로젝트 생성시 이름 입력만으로 연락처/이메일이 자동완성됩니다. 동명이인은 연락처로 구분됩니다.</p>
            {fpList.map(function(fp) {
              if (editFpId === fp.id) {
                return <div key={fp.id} style={{ display:"grid",gridTemplateColumns:"1fr 1fr 1fr auto",gap:6,marginBottom:4,alignItems:"center" }}>
                  <input value={editFp.name} onChange={function(e){setEditFp(function(p){return Object.assign({},p,{name:e.target.value});});}} style={inputS} />
                  <input value={editFp.phone} onChange={function(e){setEditFp(function(p){return Object.assign({},p,{phone:e.target.value});});}} style={inputS} />
                  <input value={editFp.email} onChange={function(e){setEditFp(function(p){return Object.assign({},p,{email:e.target.value});});}} style={inputS} />
                  <div style={{ display:"flex",gap:4 }}>
                    <button onClick={function(){saveFpEdit(fp.id);}} style={{ padding:"4px 10px",borderRadius:6,border:"none",background:OK,color:"#fff",fontSize:10,cursor:"pointer" }}>저장</button>
                    <button onClick={function(){setEditFpId(null);}} style={{ padding:"4px 10px",borderRadius:6,border:"1px solid "+G[200],background:"#fff",color:G[500],fontSize:10,cursor:"pointer" }}>취소</button>
                  </div>
                </div>;
              }
              return <div key={fp.id} style={{ display:"flex",alignItems:"center",gap:8,padding:"6px 10px",borderRadius:6,border:"1px solid "+G[200],marginBottom:4 }}>
                <span style={{ fontSize:12,color:G[700],fontWeight:600,minWidth:60 }}>{fp.name}</span>
                <span style={{ fontSize:11,color:G[500],flex:1 }}>{fp.phone}</span>
                <span style={{ fontSize:11,color:G[400],flex:1 }}>{fp.email}</span>
                <button onClick={function(){setEditFpId(fp.id);setEditFp({name:fp.name,phone:fp.phone||"",email:fp.email||""});}} style={{ background:"none",border:"none",cursor:"pointer",fontSize:10,color:A,textDecoration:"underline" }}>수정</button>
                <button onClick={function(){delFpItem(fp.id);}} style={{ background:"none",border:"none",cursor:"pointer" }}><Svg d={iX} s={13} c={G[400]} /></button>
              </div>;
            })}
            <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr 1fr auto",gap:6,marginTop:6 }}>
              <input value={newFp.name} onChange={function(e){setNewFp(function(p){return Object.assign({},p,{name:e.target.value});});}} placeholder="이름" style={inputS} />
              <input value={newFp.phone} onChange={function(e){setNewFp(function(p){return Object.assign({},p,{phone:e.target.value});});}} placeholder="연락처" style={inputS} />
              <input value={newFp.email} onChange={function(e){setNewFp(function(p){return Object.assign({},p,{email:e.target.value});});}} onKeyDown={function(e){if(e.key==="Enter")addFpItem();}} placeholder="이메일" style={inputS} />
              <button onClick={addFpItem} style={{ padding:"8px 14px",borderRadius:8,border:"1px solid "+G[200],background:"#fff",color:G[600],fontSize:12,cursor:"pointer",whiteSpace:"nowrap" }}>추가</button>
            </div>
          </div>
        </div>}

      </div>}

      {/* ── 계정 관리 탭 ── */}
      {settingTab === "accounts" && isSuper && <div>
        <div style={Object.assign({},cardS,{marginBottom:16})}>
          <div style={{ display:"flex",gap:8,flexWrap:"wrap" }}>
            <input value={accNewUser} onChange={function(e){setAccNewUser(e.target.value);}} placeholder="아이디" style={Object.assign({},inputS,{flex:1,minWidth:120})} />
            <input value={accNewName} onChange={function(e){setAccNewName(e.target.value);}} placeholder="이름" style={Object.assign({},inputS,{flex:1,minWidth:100})} />
            <input value={accNewPw} onChange={function(e){setAccNewPw(e.target.value);}} placeholder="비밀번호" type="password" style={Object.assign({},inputS,{flex:1,minWidth:120})} />
            <button onClick={doCreateAccount} style={{ padding:"9px 20px",borderRadius:8,border:"none",background:A,color:"#fff",fontSize:13,fontWeight:600,cursor:"pointer" }}>추가</button>
          </div>
          {accMsg && <div style={{ marginTop:8,fontSize:12,color:accMsg.indexOf("오류")>=0?"#DC2626":"#059669" }}>{accMsg}</div>}
        </div>
        {accounts.map(function(acc){
          return <div key={acc.id} style={Object.assign({},cardS,{marginBottom:10,padding:16})}>
            <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:acc.isSuper?0:10 }}>
              <div style={{ display:"flex",alignItems:"center",gap:8 }}>
                <div style={{ width:32,height:32,borderRadius:8,background:acc.isSuper?A+"18":acc.active?"#ECFDF5":"#FEF2F2",display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:700,color:acc.isSuper?A:acc.active?"#059669":"#DC2626" }}>{(acc.name||"?")[0]}</div>
                <div>
                  <div style={{ display:"flex",alignItems:"center",gap:6 }}>
                    <span style={{ fontSize:13,fontWeight:600,color:G[900] }}>{acc.name}</span>
                    <span style={{ fontSize:11,color:G[400] }}>@{acc.username}</span>
                    {acc.isSuper && <span style={{ fontSize:9,color:"#fff",background:A,padding:"1px 6px",borderRadius:3,fontWeight:600 }}>SUPER</span>}
                  </div>
                  <div style={{ fontSize:10,color:acc.active?"#059669":"#DC2626",marginTop:1 }}>{acc.active?"✔ 활성":"⛔ 비활성"}</div>
                </div>
              </div>
              {!acc.isSuper && <div style={{ display:"flex",gap:4 }}>
                <button onClick={async function(){ var pw = window.prompt(acc.name + " 새 비밀번호 (6자 이상):"); if(pw && pw.length >= 6){ try { await api.resetPassword(acc.id, pw); showToast(acc.name+" PW 초기화 완료"); } catch(e){ showToast("오류: "+e.message); } } }} style={{ padding:"4px 8px",borderRadius:5,border:"1px solid "+G[200],background:"#fff",color:G[500],fontSize:10,cursor:"pointer" }}>PW초기화</button>
                <button onClick={function(){toggleAccount(acc.id, acc.active);}} style={{ padding:"4px 8px",borderRadius:5,border:"1px solid "+(acc.active?"#FCA5A5":"#6EE7B7"),background:acc.active?"#FEF2F2":"#ECFDF5",color:acc.active?"#DC2626":"#059669",fontSize:10,cursor:"pointer" }}>{acc.active?"비활성":"활성"}</button>
                <button onClick={async function(){ if(!window.confirm(acc.name+" 계정을 삭제하시겠습니까?\n※ 이 계정이 만든 데이터(업체·FP·상담 등)가 있으면 서버가 삭제를 거부합니다. 그 경우 [비활성] 토글로 로그인만 차단하세요.")) return; try { await api.deleteAccount(acc.id); showToast("계정 삭제 완료"); loadAccounts(); } catch(e){ showToast("오류: "+e.message); } }} style={{ padding:"4px 8px",borderRadius:5,border:"1px solid #FCA5A5",background:"#FEF2F2",color:"#DC2626",fontSize:10,cursor:"pointer" }}>삭제</button>
              </div>}
            </div>
            {!acc.isSuper && <div style={{ display:"flex",gap:4,flexWrap:"wrap",alignItems:"center",paddingTop:8,borderTop:"1px solid "+G[100] }}>
              <span style={{ fontSize:10,color:G[400],marginRight:2 }}>모듈:</span>
              {allModules.filter(function(m){return m.is_active;}).map(function(mod){
                var myMods = permMap[acc.id] || [];
                var on = myMods.indexOf(mod.id) >= 0;
                return <button key={mod.id} onClick={function(){togglePerm(acc.id,mod.id);}} style={{ padding:"3px 8px",borderRadius:5,border:on?"1px solid "+A:"1px solid "+G[200],background:on?A+"10":"#fff",color:on?A:G[400],fontSize:10,fontWeight:on?600:400,cursor:"pointer",transition:"all .1s" }}>{on?"✓ ":""}{(mod.label||"").replace("\n"," ")}</button>;
              })}
            </div>}
          </div>;
        })}
      </div>}

      {/* ── 모듈 관리 탭 ── */}
      {settingTab === "modules" && isSuper && <div>
        <div style={Object.assign({},cardS,{marginBottom:16})}>
          <div style={{ fontSize:14,fontWeight:700,color:G[900],marginBottom:12 }}>새 모듈 추가</div>
          <div style={{ display:"flex",gap:8,flexWrap:"wrap",marginBottom:8 }}>
            <input value={newModKey} onChange={function(e){setNewModKey(e.target.value);}} placeholder="key (영문, 예: report)" style={Object.assign({},inputS,{flex:1,minWidth:120})} />
            <input value={newModLabel} onChange={function(e){setNewModLabel(e.target.value);}} placeholder="표시명 (예: 가결산 리포트)" style={Object.assign({},inputS,{flex:1,minWidth:150})} />
            <input value={newModRoute} onChange={function(e){setNewModRoute(e.target.value);}} placeholder="screen (비워두면 준비중)" style={Object.assign({},inputS,{flex:1,minWidth:130})} />
          </div>
          <div style={{ display:"flex",gap:8,alignItems:"center" }}>
            <label style={{ fontSize:11,color:G[500] }}>색상</label>
            <input type="color" value={newModColor} onChange={function(e){setNewModColor(e.target.value);}} style={{ width:32,height:28,border:"none",cursor:"pointer" }} />
            <label style={{ fontSize:11,color:G[500] }}>배경</label>
            <input type="color" value={newModBg} onChange={function(e){setNewModBg(e.target.value);}} style={{ width:32,height:28,border:"none",cursor:"pointer" }} />
            <div style={{ flex:1 }}></div>
            <button onClick={doCreateModule} style={{ padding:"8px 20px",borderRadius:8,border:"none",background:A,color:"#fff",fontSize:13,fontWeight:600,cursor:"pointer" }}>추가</button>
          </div>
          {modMsg && <div style={{ marginTop:8,fontSize:12,color:modMsg.indexOf("오류")>=0?"#DC2626":"#059669" }}>{modMsg}</div>}
        </div>
        <div style={cardS}>
          <div style={{ fontSize:14,fontWeight:700,color:G[900],marginBottom:12 }}>모듈 목록 ({allModules.length})</div>
          {allModules.map(function(mod){
            return <div key={mod.id} style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 0",borderBottom:"1px solid "+G[100] }}>
              <div style={{ display:"flex",alignItems:"center",gap:10 }}>
                <div style={{ width:36,height:36,borderRadius:10,background:mod.bg_color||"#EFF6FF",display:"flex",alignItems:"center",justifyContent:"center" }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={mod.color||"#1E40AF"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d={mod.icon_path||"M4 6h16M4 12h16M4 18h16"} /></svg>
                </div>
                <div>
                  <div style={{ fontSize:14,fontWeight:600,color:G[900] }}>{mod.label}</div>
                  <div style={{ fontSize:11,color:G[400] }}>key: {mod.key} {mod.screen_route ? " | route: "+mod.screen_route : " | 준비중"}</div>
                </div>
              </div>
              <div style={{ display:"flex",gap:6,alignItems:"center" }}>
                <button onClick={function(){toggleModuleActive(mod);}} style={{ padding:"4px 10px",borderRadius:6,border:"1px solid "+(mod.is_active?"#059669":"#DC2626"),background:mod.is_active?"#ECFDF5":"#FEF2F2",color:mod.is_active?"#059669":"#DC2626",fontSize:11,fontWeight:600,cursor:"pointer" }}>{mod.is_active?"활성":"비활성"}</button>
                <button onClick={function(){doDeleteModule(mod);}} style={{ padding:"4px 10px",borderRadius:6,border:"1px solid #DC2626",background:"#fff",color:"#DC2626",fontSize:11,cursor:"pointer" }}>삭제</button>
              </div>
            </div>;
          })}
        </div>
      </div>}

      <Toast msg={stToast} />
    </div>
  );
}
